import "./index.css";
import { useState, useEffect } from "react";
import { Select, notification } from "antd";
import { useAuth } from "../../context/auth";

const MerchantDropdown = ({ setSelectedMerchants, ...props }) => {
  const { accessToken } = useAuth()

  const [merchants, setMerchants] = useState([]);
  useEffect(() => {
    async function getMerchants() {
      const url = new URL('/api/merchant', window.location);
      url.searchParams.append('mode', 'dropdown')

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      })
      if (res.ok) {
        const { merchants } = await res.json()
        setMerchants(merchants)
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    getMerchants()
  }, [accessToken]);

  return (
    <Select
      {...props}
      showSearch
      placeholder="Cluster Name"
      maxTagCount="responsive"
      maxTagPlaceholder={(ids) => `+ ${ids.length}`}
      optionFilterProp="children"
    >
      {setSelectedMerchants && (
        <div disabled={true}>
          <span
            onClick={() => setSelectedMerchants(merchants.map(merchant => merchant.id))}
            style={{
              display: "inline-block",
              color: "#286FBE",
              cursor: "pointer",
            }}
          >
            SELECT ALL
          </span>
        </div>
      )}
      {merchants.map(merchant => (
        <Select.Option key={merchant.id} value={merchant.id}>
          {merchant.nameEn}
        </Select.Option>
      ))}
    </Select>
  );
};

export default MerchantDropdown;
